.imagePopup {
	position: absolute;
	top: 100%;
	left: 0;
	background: $whiteColor;
	border-radius: 8px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
	width: 320px;
	overflow: hidden;
	border: 1px solid $greyColor5;
	z-index: 50;
	margin-top: 8px;
}

.popupContent {
	padding: 16px;
}

.formGroup {
	margin-bottom: 12px;

	&:last-child {
		margin-bottom: 0;
	}

	label {
		display: block;
		margin-bottom: 6px;
		font-size: 13px;
		color: $blackColor;
		font-weight: 500;
	}
}

.input {
	width: 100%;
	padding: 8px 12px;
	border: 1px solid $greyColor5;
	border-radius: 6px;
	font-size: 14px;
	color: $blackColor;
	transition: border-color 0.2s;

	&:focus {
		outline: none;
		border-color: $activeColor;
		box-shadow: 0 0 0 2px rgba($activeColor, 0.1);
	}

	&::placeholder {
		color: $greyColor;
	}
}

.popupActions {
	display: flex;
	justify-content: flex-end;
	gap: 8px;
	padding: 12px 16px;
	border-top: 1px solid $greyColor5;
	background: #f9f9f9;
}

.button {
	padding: 6px 12px;
	border-radius: 4px;
	font-size: 13px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s;
	border: 1px solid transparent;

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
}

.buttonPrimary {
	background: $activeColor;
	color: white;

	&:hover:not(:disabled) {
		background: $hoverColor;
	}
}

.buttonSecondary {
	background: $whiteColor;
	color: $blackColor;
	border-color: $greyColor5;

	&:hover {
		background: $greyColor5;
	}
}
